import React from 'react';
import ownerPhoto from '../assets/photo-of-owner.png';

const About = () => {
  return (
    <div style={{ padding: '2rem 0' }}>
      <div className="container">
        <h1 style={{ marginBottom: '2rem' }}>About Star Tidbits</h1>
        
        {/* Company Story */}
        <div className="grid grid-2" style={{ marginBottom: '3rem', alignItems: 'center' }}>
          <div>
            <h2>Our Story</h2>
            <p>
              "Star Tidbits" is the leading tidbits brand in Singapore. It was established under the name "Sakthi Vinayaga Food Industries Pte Ltd" in 1998 by Mr. and Mrs. Kannan Jayabal. Murukku is one of the most popular snacks in Singapore. We specialize in the manufacturing and distribution of all kinds of murukku, savories, peanuts, and Indian sweets.
            </p>
            <p>
              Star Tidbits products are made from authentic recipes using the best quality ingredients. We manufacture murukku in many flavors and shapes. We work hand in hand with our consumers to prepare new products tailored to their personal tastes. Our success is due to our ability to provide quality products that are available at a low price, as well as 24-hour customer service.
            </p>
            <p>
              Star Tidbits products are available in almost every retail shop in Singapore. All the products we provide from our branches "Sri Sakthi Vinayaga Foods Pte Ltd", "Five Star Tid Bits", India, "Star Tid Bits Sdn Bhd", Malaysia.
            </p>
          </div>
          <div style={{ textAlign: 'center' }}>
            <div style={{ marginBottom: '1rem' }}>
              <img 
                src={ownerPhoto} 
                alt="Owner" 
                style={{ 
                  maxWidth: '200px', 
                  width: '100%', 
                  height: 'auto',
                  borderRadius: '12px'
                }} 
              />
            </div>
            <p style={{ fontStyle: 'italic', color: 'var(--primary-saffron)' }}>
              Managing Director of Star Tidbits<br/>
              Mr Kannan Jaybal
            </p>
          </div>
        </div>

        {/* Manufacturing & Quality */}
        <div className="card" style={{ marginBottom: '3rem' }}>
          <h2>Manufacturing & Quality</h2>
          <div className="grid grid-3" style={{ marginTop: '2rem', gap: '3rem' }}>
            <div className="card" style={{ textAlign: 'center', padding: '1.5rem', backgroundColor: 'white' }}>
              <div style={{ fontSize: '3rem', marginBottom: '1.5rem' }}>🏭</div>
              <h3 style={{ marginBottom: '1rem' }}>Modern Facility</h3>
              <p style={{ lineHeight: '1.6' }}>State of art manufacturing facility are in Malaysia and India</p>
            </div>
            <div className="card" style={{ textAlign: 'center', padding: '1.5rem', backgroundColor: 'white' }}>
              <div style={{ fontSize: '3rem', marginBottom: '1.5rem' }}>✅</div>
              <h3 style={{ marginBottom: '1rem' }}>Quality Control</h3>
              <p style={{ lineHeight: '1.6' }}>HACCP certified processes ensuring consistent quality and food safety</p>
            </div>
            <div className="card" style={{ textAlign: 'center', padding: '1.5rem', backgroundColor: 'white' }}>
              <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>👨‍🍳</div>
              <h3>Skilled Team</h3>
              <p>15 experienced staff members trained in traditional preparation methods</p>
            </div>
          </div>
        </div>

        {/* Certifications */}
        <div style={{ backgroundColor: 'var(--neutral-light)', padding: '2rem', borderRadius: '12px', marginBottom: '3rem' }}>
          <h2 style={{ textAlign: 'center', marginBottom: '2rem' }}>Certifications & Credentials</h2>
          <div className="grid grid-2">
            <div>
              <h3>Business Registration</h3>
              <ul style={{ marginLeft: '1rem' }}>
                
                <li><strong>GST Registration:</strong> 200718056C</li>
                
              </ul>
            </div>
            <div>
              <h3>Quality Certifications</h3>
              <ul style={{ marginLeft: '1rem' }}>
                
                <li><strong>Halal Certified</strong> - MUIS Singapore</li>
               
              </ul>
            </div>
          </div>
        </div>

        {/* Location & Contact */}
        <div className="grid grid-2">
          <div className="card">
            <h2>Visit Our Facility</h2>
            <div style={{ marginBottom: '1rem' }}>
              <h3>Address:</h3>
              <p>
                No.1 Bukit Batok Crescent<br/>
                #04-13 Wcega Plaza<br/>
                Singapore 658064
              </p>
            </div>
            <div style={{ marginBottom: '1rem' }}>
              <h3>Operating Hours:</h3>
              <p>
                Monday - Friday: 8:00 AM - 5:00 PM<br/>
                Saturday: 8:00 AM - 3:00 PM<br/>
                Sunday: Closed
              </p>
            </div>
            <div>
              <h3>Contact:</h3>
              <p>
                📱 +65 98592974<br/>
                ✉️ startidbits@gmail.com
              </p>
            </div>
          </div>

          <div className="card">
            <h2>Our Values</h2>
            <div style={{ marginBottom: '1.5rem' }}>
              <h3 style={{ color: 'var(--primary-saffron)' }}>🌿 Authenticity</h3>
              <p>Traditional recipes and methods preserved across generations</p>
            </div>
            <div style={{ marginBottom: '1.5rem' }}>
              <h3 style={{ color: 'var(--accent-green)' }}>🤝 Partnership</h3>
              <p>Building long-term relationships with our wholesale customers</p>
            </div>
            <div style={{ marginBottom: '1.5rem' }}>
              <h3 style={{ color: 'var(--soft-gold)' }}>⭐ Quality</h3>
              <p>Never compromising on ingredients or preparation standards</p>
            </div>
            <div>
              <h3 style={{ color: 'var(--primary-saffron)' }}>🚀 Innovation</h3>
              <p>Adapting to modern needs while preserving traditional taste</p>
            </div>
          </div>
        </div>

        {/* Map Placeholder */}
        <div style={{ marginTop: '3rem', textAlign: 'center', padding: '3rem', backgroundColor: 'var(--white)', borderRadius: '12px' }}>
          <h3>Find Us on the Map</h3>
          <div style={{ 
            backgroundColor: '#f0f0f0', 
            height: '300px', 
            borderRadius: '8px', 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center',
            marginTop: '1rem'
          }}>
            {/* <p style={{ color: '#666' }}>🗺️ Interactive map would be embedded here</p> */}
            <iframe 
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3988.7293815368826!2d103.7543684869717!3d1.3386673951643036!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da1123ee91ad29%3A0x1651d1694f742aca!2sStar%20Tid%20Bits%20Pte%20Ltd!5e0!3m2!1sen!2sus!4v1763609036212!5m2!1sen!2sus" 
              width="100%" 
              height="300" 
              style={{ border: 0, borderRadius: '8px' }} 
              allowFullScreen="" 
              loading="lazy" 
              referrerPolicy="no-referrer-when-downgrade"
              title="Star Tidbits Location"
            />
          </div>
          <p style={{ marginTop: '1rem', fontSize: '0.875rem', color: 'var(--neutral-dark)', opacity: 0.7 }}>
            Easy access via MRT: Jurong East (5 min walk) | Free parking available
          </p>
        </div>
      </div>
    </div>
  );
};

export default About;